import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { parseZone } from 'moment';
import { Subject } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';
import { CommonService } from '../../shared/services/common.service';
import { UtilService } from '../../shared/services/util.service';
import { CommonBookingService } from '../shared/common-booking.service';
import { MyBookingsService } from './my-bookings.service';
import { CreateBookingService } from '../create-booking/create-booking.service';

@Component({
  selector: 'app-my-bookings',
  templateUrl: './my-bookings.component.html',
  styleUrls: ['./my-bookings.component.scss', '../../shared/styles/form-input.scss']
})

export class MyBookingsComponent implements OnInit, OnDestroy {

  constructor(private authService: AuthService, private activatedRoute: ActivatedRoute,
              private router: Router, private utilService: UtilService, private changeDetectorRef: ChangeDetectorRef,
              private commonService: CommonService, private commonBookingService: CommonBookingService,
              public myBookingService: MyBookingsService, public createBookingService: CreateBookingService) {

  }

  public tabDetails = [
    {
      value: 'upcoming',
      label: 'Upcoming'
    },
    {
      value: 'past',
      label: 'Past',
    }
  ];

  public bookingsToastMessage: string;
  bookings = [];
  filteredBookings: any = [];
  private searchQuery: any;
  public showBookingDetails = false;
  public showRequestDetails = false;
  public bookingDetails: any;
  public requestDetails: any;
  public displayBookings: any;
  // private minBookingsCount = 30;
  // public currentDisplayCount = this.minBookingsCount;
  public searchInput: any;
  private searchTimer: any;
  private startDate: any;
  private endDate: any;
  public config: any;
  public inputControlStartDate: any;
  public inputControlEndDate: any;
  public tabValue = 'upcoming';
  private configUtils: any;
  public cancelCutOffDetails: any;
  public editCutOffDetails: any;
  public isLoading = true;
  public showCancelConfirmDialog = false;
  public cancelBookingId: any;
  public toastCallback: any;
  public showHistoryView = false;
  public bookingHistoryUnformatted: any;
  public bookingHistoryId: any;
  public displayInvalidDateError = false;
  public bookingTimer: any;
  cancelPopUpConfig: any;
  destroy$ = new Subject();
  public dateMaxConfig: any;
  upcomingOnly = false;
  totalPages = 0;
  currentPage = 0;
  pageSize = 10;
  miscellConfig: any;
  showHeaderSection = true;
  bookingLabel = 'Upcoming Booking';
  pageIndexNew = 1;
  currentPageSize = 5;
  totalNoOfRows = 0;
  showPagination = false;
  paginationId = 'my-booking-pagination';
  configComplete: any;

  /*onBookingSearch() {
    const search = new RegExp(this.searchInput, 'gi');
    this.searchBooking = this.bookings.filter((booking) => {
      if ((booking.bookingId.search(search)) > -1) {
        return true;
      } else if (booking.requestId.search(search) > -1) {
        return true;
      } else {
        for (const stop of booking.stops) {
          for (const rider of stop.riders) {
            if (rider.name.search(search) > -1 || rider.email.search(search) > -1) {
              return true;
            }
          }
        }
      }
      return false;
    });
    this.paginateBookings();
  }*/

  searchTimeout;

  ngOnInit() {

    this.createBookingService.showCreateBookingButton.next(true);
    if (localStorage.getItem('bookingId')
      && localStorage.getItem('startDate')) {
      this.showHeaderSection = false;
    }
    this.commonService.fetchMiscConfig().subscribe((response: any) => {
      this.miscellConfig = response;
      if (response && response['pageSize']) {
        this.pageSize = parseInt(response['pageSize']);
      }
      this.authService.getServerTime({ buid: this.authService.user.buId }).subscribe((res) => {
        this.authService.serverTime = res;
        this.getUpcomingDateConfigs();
      });
    });
    this.getCancelCutOff();
    this.getEditCutOff();
    this.setReasonConfig();
  }

  setReasonConfig() {
    this.commonService.fetchConfig().subscribe((response: any) => {
      this.configComplete = response;
      const reasonConfigSection = this.commonService.getConfigForElementKey(response, 'Booking Action Popup');
      this.cancelPopUpConfig = this.commonService.getConfigForElementKey(reasonConfigSection, 'Cancel Booking');
    });
  }

  showBookingActionToasts() {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        if (params.createdRequest) {
          this.bookingsToastMessage = 'Request created successfully';
          this.toastCallback = (action) => {
            if (action === 'View') {
              this.handleShowRequestDetails({ id: params.createdRequest });
            }
          };
        } else if (params.updatedBooking) {
          this.bookingsToastMessage = 'Booking updated successfully';
          this.toastCallback = (action) => {
            if (action === 'View') {
              this.handleShowBookings({ id: params.updatedBooking });
            }
          };
        }
        this.router.navigate(['/bookings']);
      });
  }

  getPastDateConfigs() {

      this.configUtils = this.commonService.getConfigForElementKey(this.configComplete, 'Past Tab Date Section');
      const startDateConfig = this.commonService.getConfigForElementKey(this.configUtils, 'Start Date').config.defaultValue;
      const endDateConfig = this.commonService.getConfigForElementKey(this.configUtils, 'End Date').config.defaultValue;

      this.startDate = this.utilService.getMoment().add(Number(startDateConfig), 'days');
      this.endDate = this.utilService.getMoment().add(Number(endDateConfig) + 1, 'days');
      this.config = {
        minDate: '',
        maxDate: this.utilService.getMoment().add(-1, 'days')
      };
      this.inputControlStartDate = new FormControl([this.startDate]);
      this.inputControlEndDate = new FormControl([this.endDate]);
      // this.inputControlStartDate = new FormControl([moment()]);
      // this.inputControlEndDate = new FormControl([moment()]);
      this.dateMaxConfig = {
        startDate: this.startDate,
        endDate: this.endDate,
        minDate: '',
        maxDate: this.utilService.getMoment()
      };
      this.getBookings();


  }

  getUpcomingDateConfigs() {
      this.configUtils = this.commonService.getConfigForElementKey(this.configComplete, 'Upcoming Tab Date Section');
      const startDateConfig = this.commonService.getConfigForElementKey(this.configUtils, 'Start Date').config.defaultValue;
      const endDateConfig = '+30';

      this.startDate = this.utilService.getMoment().add(Number(startDateConfig), 'days');
      this.endDate = this.utilService.getMoment().add(Number(endDateConfig), 'days');
      this.config = {
        minDate: this.utilService.getMoment(),
        maxDate: ''
      };
      this.inputControlStartDate = new FormControl([this.startDate]);
      this.inputControlEndDate = new FormControl([this.endDate]);
      this.dateMaxConfig = {
        startDate: this.startDate,
        endDate: this.endDate,
        minDate: this.utilService.getMoment(),
        maxDate: ''
      };
      this.getBookings();
  }

  pageChanged(event) {
    this.currentPage = (event - 1);
    this.getBookings();
  }

  getBookings(searchString = "") {
    const searchKey = localStorage.getItem('bookingId');
    searchString = searchKey ? searchKey : searchString;
    const date = localStorage.getItem('startDate');

    this.searchQuery = {
      employeeGuid: this.authService.user.employeeGuid,
      startDate: date ? (date + ' 00:00') : (this.startDate.format('DD-MM-YYYY') + ' 00:00'),
      endDate: date ? (date + ' 23:59') : (this.endDate.format('DD-MM-YYYY') + ' 23:59'),
      buid: this.authService.user.buId,
      myBookings: true,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
    };
    const queryString = {
      searchText: searchString,
      tabValue: this.tabValue
    };
    if (this.bookingTimer) {
      this.bookingTimer.unsubscribe();
    }
    // auto call the api until this component is destroyed in 60sec interval
    this.isLoading = true;
    this.commonBookingService.fetchBookings(queryString, this.searchQuery).subscribe((response) => {
        this.bookings = response['spotBookingDTO'];
        this.totalNoOfRows = this.bookings.length;
        // let startFrom = this.pageIndexNew * this.currentPageSize - this.currentPageSize;
        // let takeRows =  this.pageIndexNew * this.currentPageSize;
        this.filteredBookings = this.bookings.slice(0, 11);
        // this.filteredBookings = this.bookings.slice(0,1);
        if (localStorage.getItem('startDate') && localStorage.getItem('bookingId')) {
          localStorage.removeItem('startDate');
          localStorage.removeItem('bookingId');
          this.bookingTimer.unsubscribe();
        }
        if (this.miscellConfig['billAmountFrom'] && this.miscellConfig['billAmountFrom'] === 'Vendor') {
          this.bookings.forEach((booking) => {
            booking['bookingAmount'] = booking['vendorBillAmount'] ? booking['vendorBillAmount'] : null;
          });
        }
        this.totalPages = response['paginationCount'];
        this.sortBookings();
        this.isLoading = false;
        this.showBookingActionToasts();
      }, () => {
        this.isLoading = false;
      });

    this.myBookingService.pastStartDate.next(this.searchQuery.startDate);
    this.myBookingService.pastEndDate.next(this.searchQuery.endDate);
  }

  sortBookings() {
    this.filteredBookings.sort((a, b) => this.utilService.getMoment(a.startTime) - this.utilService.getMoment(b.startTime));
  }

  getBookingDetails(bookingId: any) {
    const searchQuery = {
      bookingId
    };
    this.commonBookingService.fetchBookingDetails(searchQuery).subscribe((response) => {
      this.bookingDetails = response;
    });
  }

  getRequestDetails(requestId: any) {
    const searchQuery = {
      requestId
    };
    this.commonBookingService.fetchRequestDetails(searchQuery).subscribe((response) => {
      this.requestDetails = response;
    });
  }

  cancelBooking(bookingId: any, reason: string) {
    const body = {
      modifierGuid: this.authService.user.employeeGuid,
      modifierBuid: this.authService.user.buId,
      bookingId,
      reason,
    };
    const requestBody = [];
    requestBody.push(body);
    this.commonBookingService.cancelBooking(requestBody).subscribe((response) => {
      this.getBookings();
      this.showCancelConfirmDialog = false;
    });
  }

  getCancelCutOff() {
    this.commonService.fetchCancelConfig().subscribe((response) => {
      this.cancelCutOffDetails = response;
      this.commonService.cancelcuttoffObj.next(String(response.cutOffMins));
    });
  }

  getEditCutOff() {
    this.commonService.fetchEditConfig().subscribe((response) => {
      this.editCutOffDetails = response;
      this.commonService.editcuttoffObj.next(String(response.cutOffMins));
    });
  }

  onTabChange(tabValue: any) {
    this.resetPagination();
    this.tabValue = tabValue;
    // this.currentDisplayCount = this.minBookingsCount;
    this.displayInvalidDateError = false;
    if (this.tabValue === 'past') {
      this.showPagination = true;
      this.getPastDateConfigs();
    } else if (this.tabValue === 'upcoming') {
      this.showPagination = false;
      this.getUpcomingDateConfigs();
    }
  }

  toggleToast() {
    this.bookingsToastMessage = '';
  }
  onSearchInputChange(event) {
    if (event.keyCode === 13 && this.searchInput && this.searchInput.length > 2) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(this.searchBookingsCall.bind(this), 500);
    }
    else if (this.searchInput === "") {
      this.resetPagination();
      this.upcomingOnly = false;
      this.bookingLabel = "Upcoming Booking";
      if (this.tabValue === 'past') {
        this.showPagination = true;
      } else {
        this.showPagination = false;
      }
      this.getBookings();
    }
  }

  searchBookingsCall() {
    this.resetPagination();
    // Clearing the auto reload bookings timer
    if (this.bookingTimer) {
      this.bookingTimer.unsubscribe();
    }
    this.upcomingOnly = true;
    this.bookingLabel = "Booking Results";
    this.showPagination = true;
    this.getBookings(this.searchInput);
  }

  resetPagination() {
    // this.currentPage = 0;
    // this.totalPages = 0;
    this.pageIndexNew = 1;
    this.currentPageSize = 5;
    this.totalNoOfRows = 0;
  }

  showPaginationCallback(event) {
    if (event) {
      this.searchInput = '';
      this.showPagination = true;
      this.upcomingOnly = true;
      this.bookingLabel = "Upcoming Booking";
      this.resetPagination();
      this.getBookings();
    } else {
      if (this.tabValue === 'past') {
        this.showPagination = true;
      } else {
        this.showPagination = event;
      }
      this.searchInput = '';
      this.upcomingOnly = false;
      this.bookingLabel = "Upcoming Booking";
      this.resetPagination();
      this.getBookings();
    }
  }

  onStartDateChange(dateValue: any) {
    this.startDate = dateValue.next[0];
    if (this.endDate && this.startDate.isAfter(this.endDate, 'day')) {
      this.setDateFormControlError();
    } else {
      this.removeFormControlError();
      this.resetPagination();
      this.getBookings();
    }
    this.changeDetectorRef.detectChanges();
  }

  setDateFormControlError() {
    this.inputControlStartDate.setErrors({ incorrectStartDate: true });
    this.inputControlEndDate.setErrors({ incorrectEndDate: true });
    this.displayInvalidDateError = true;
  }

  removeFormControlError() {
    this.inputControlEndDate.setErrors(null);
    this.inputControlStartDate.setErrors(null);
    this.displayInvalidDateError = false;
  }

  onEndDateChange(dateValue: any) {
    this.endDate = dateValue.next[0];
    if (this.startDate && this.endDate.isBefore(this.startDate, 'day')) {
      this.setDateFormControlError();
    } else {
      this.removeFormControlError();
      this.resetPagination();
      this.getBookings();
    }
    this.changeDetectorRef.detectChanges();
  }

  selectedDate(dateValue: any) {
    this.startDate = dateValue.date.startDate ? parseZone(dateValue.date.startDate, 'DD/MM/YYYY') : '';
    this.endDate = dateValue.date.endDate ? parseZone(dateValue.date.endDate, 'DD/MM/YYYY') : '';
    if (this.endDate && this.startDate.isAfter(this.endDate, 'day')) {
      this.setDateFormControlError();
    } else if (this.startDate && this.endDate.isBefore(this.startDate, 'day')) {
      this.setDateFormControlError();
    } else {
      this.removeFormControlError();
      this.resetPagination();
    }
    this.dateMaxConfig = {
      startDate: this.startDate,
      endDate: this.endDate,
    };
    this.getBookings();
    this.changeDetectorRef.detectChanges();
  }

  handleShowBookings(bookingId: any) {
    this.showBookingDetails = true;
    if (bookingId.id) {
      this.getBookingDetails(bookingId.id);
    }
  }

  handleCloseBookingDetails() {
    this.showBookingDetails = false;
  }

  handleShowRequestDetails(requestId: any) {
    this.showRequestDetails = true;
    if (requestId.id) {
      this.getRequestDetails(requestId.id);
    }
  }

  handleCloseRequestDetails() {
    this.showRequestDetails = false;
  }

  handleCancelBooking(reason: string) {
    if (this.cancelBookingId) {
      this.isLoading = true;
      this.cancelBooking(this.cancelBookingId, reason);
    }
  }

  toggleCancelConfirmDialog(bookingId: any) {
    this.showCancelConfirmDialog = true;
    this.cancelBookingId = bookingId.id;
  }

  dismissCancelBookingDialog() {
    this.showCancelConfirmDialog = false;
    this.cancelBookingId = null;
  }

  handleShowHistoryView(booking: any) {
    if (booking.id) {
      this.showHistoryView = true;
      this.bookingHistoryId = booking.id;
      this.isLoading = true;
    }
  }

  toggleLoading(value: any) {
    this.isLoading = value;
  }

  handleCloseHistoryView() {
    this.showHistoryView = false;
    this.bookingHistoryId = null;
  }
  pageChangedNew(event: number) {
    this.pageIndexNew = event;
    this.filteredBookings = this.bookings.slice(this.pageIndexNew * this.currentPageSize - this.currentPageSize, this.pageIndexNew * this.currentPageSize);
  }

  showNumberOfRecords(size: number) {
    this.currentPageSize = size;
    this.pageIndexNew = 1;
    this.filteredBookings = this.bookings.slice(this.pageIndexNew * this.currentPageSize - this.currentPageSize, this.pageIndexNew * this.currentPageSize);

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
